import React, { Fragment } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

export default function CustomModal({ children, trigger }) {
	const [ showModal, setShowModal ] = React.useState(false);
	return (
		<Fragment>
			<span onClick={() => setShowModal(true)}>{trigger}</span>
			<Modal animationDuration={1} open={showModal} onClose={() => setShowModal(false)} center>
				<div className="p-3 min-w-full">{children}</div>
			</Modal>
		</Fragment>
	);
}
